module.exports = __webpack_public_path__ + "img/xzy02.51eae97a.png";